import './src/styles/normalize.css'
import './src/styles/index.css'
import { Helmet } from "react-helmet"
require("prismjs/themes/prism-tomorrow.css")
const React = require("react")

export const wrapRootElement = ({ element }) => {
    return (
      <>
        {element}
        <Helmet>
        <meta name="monetization" content="$ilp.uphold.com/PWGGR2gyY7kz"/>
        {typeof window !== "undefined" && (
            <script async src="https://cdn.splitbee.io/sb.js"></script>
        )}
        </Helmet>
      </>
    )
  }